module.exports = __webpack_public_path__ + "static/media/course_steps_ru.cd0fff18.jpg";